import { render, staticRenderFns } from "./batchSendEmail.vue?vue&type=template&id=54581c9b&scoped=true&"
import script from "./batchSendEmail.vue?vue&type=script&lang=js&"
export * from "./batchSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./batchSendEmail.vue?vue&type=style&index=0&id=54581c9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54581c9b",
  null
  
)

export default component.exports